import { type JSX, useState } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';

import { ActionButtonWrapper } from './ActionButtonWrapper';
import { CustomButton } from './CustomButton';
import { MobileShareModal, usePreloadMobileShareModal } from './MobileShareModal';
import { useMobileModalContext } from './shared/useMobileModalContext';

type Props = {
	sticky: boolean;
	visible: boolean;
	hideSocialProof?: boolean;
};

export function MobileShareButtonContainer({ sticky, visible, hideSocialProof = false }: Props): JSX.Element {
	const [isOpen, setIsOpen] = useState(false);

	usePreloadMobileShareModal();

	const openModal = () => {
		setIsOpen(true);
	};

	const context = useMobileModalContext();

	return (
		<>
			<ActionButtonWrapper visible={visible} sticky={sticky} hideSocialProof={hideSocialProof}>
				<CustomButton inverted onClick={openModal} data-qa="mobile-share-button">
					<Translate value="fe.components.petition_share.action" />
				</CustomButton>
			</ActionButtonWrapper>
			<MobileShareModal context={context} isOpen={isOpen} setIsOpen={setIsOpen} />
		</>
	);
}
